import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const openPDF = () => {
  window.open("test.pdf");
};

const __returned__ = { openPDF }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})